<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 12.25C1.5 18.049 6.20101 22.75 12 22.75C17.799 22.75 22.5 18.049 22.5 12.25C22.5 6.45101 17.799 1.75 12 1.75C6.20101 1.75 1.5 6.45101 1.5 12.25ZM3 12.25C3 7.27944 7.02944 3.25 12 3.25C16.9706 3.25 21 7.27944 21 12.25C21 17.2206 16.9706 21.25 12 21.25C7.02944 21.25 3 17.2206 3 12.25ZM12.75 16.5V9.75H9.75V11.25H11.25V16.5H9V18H15V16.5H12.75ZM10.875 6.375C10.875 5.75368 11.3787 5.25 12 5.25C12.6213 5.25 13.125 5.75368 13.125 6.375C13.125 6.99632 12.6213 7.5 12 7.5C11.3787 7.5 10.875 6.99632 10.875 6.375Z"
      fill="#0DCAF0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 12.25C1.5 18.049 6.20101 22.75 12 22.75C17.799 22.75 22.5 18.049 22.5 12.25C22.5 6.45101 17.799 1.75 12 1.75C6.20101 1.75 1.5 6.45101 1.5 12.25ZM3 12.25C3 7.27944 7.02944 3.25 12 3.25C16.9706 3.25 21 7.27944 21 12.25C21 17.2206 16.9706 21.25 12 21.25C7.02944 21.25 3 17.2206 3 12.25ZM12.75 16.5V9.75H9.75V11.25H11.25V16.5H9V18H15V16.5H12.75ZM10.875 6.375C10.875 5.75368 11.3787 5.25 12 5.25C12.6213 5.25 13.125 5.75368 13.125 6.375C13.125 6.99632 12.6213 7.5 12 7.5C11.3787 7.5 10.875 6.99632 10.875 6.375Z"
      fill="black"
      fill-opacity="0.8"
    />
  </svg>
</template>
